import { Routes } from '@angular/router';
import { AmplifyAuthGuardService } from 'src/app/core/guards/amplify-auth-guard.service';
import { OktaAuthGuardService } from 'src/app/core/guards/okta-auth-guard.service';
import { CampaignAnalyticsComponent } from 'src/app/features/campaigns/campaign-analytics/campaign-analytics.component';
import { CampaignDeliveriesComponent } from 'src/app/features/campaigns/campaign-analytics/campaign-deliveries/campaign-deliveries.component';
import { CampaignsComponent } from 'src/app/features/campaigns/campaign-table/campaigns.component';
import { ModalContainerCampaignComponent } from 'src/app/features/campaigns/campaign-table/view-campaign/modal-container/modal-container.component';
import { ContentComponent } from 'src/app/features/content/content-table/content.component';
import { DrbDiffComponent } from 'src/app/features/drbs/drb-diff/drb-diff.component';
import { DrbSourcesComponent } from 'src/app/features/drbs/drb-sources/drb-sources.component';
import { ViewDrbComponent } from 'src/app/features/drbs/view-drb/view-drb.component';
import { InsightsComponent } from 'src/app/features/insights/insights-table/insights.component';
import { ModalContainerInsightComponent } from 'src/app/features/insights/insights-table/view-insight/modal-container/modal-container.component';
import { CreateCleanScoreComponent } from 'src/app/features/qa-testing/clean-score/create-clean-score/create-clean-score.component';
import { ViewCleanScoreComponent } from 'src/app/features/qa-testing/clean-score/view-clean-score/view-clean-score.component';
import { CleanTimeEstimatesComponent } from 'src/app/features/qa-testing/clean-time-estimates/clean-time-estimates.component';
import { MyRobotsComponent } from 'src/app/features/qa-testing/my-robots/my-robots.component';
import { QaTestingComponent } from 'src/app/features/qa-testing/qa-tool/qa-testing.component';
import { QuickStartComponent } from 'src/app/features/quick-start/quick-start.component';
import { RobotFamilyMetadataComponent } from 'src/app/features/robot-family-metadata/robot-family-metadata-table/robot-family-metadata.component';
import { SurveysComponent } from 'src/app/features/surveys/surveys-table/surveys.component';

export const QA_ROUTES: Routes = [
  {
    path: 'qa-testing/clean-score/create',
    component: CreateCleanScoreComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/clean-score/view',
    component: ViewCleanScoreComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/qa-tool',
    component: QaTestingComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/my-robots',
    component: MyRobotsComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'qa-testing/cleaning-estimates',
    component: CleanTimeEstimatesComponent,
    canActivate: [OktaAuthGuardService]
  }
];

export const CAMPAIGN_ROUTES: Routes = [
  {
    path: 'campaigns/table',
    component: CampaignsComponent,
    children: [{ path: ':id', component: ModalContainerCampaignComponent }]
  },
  {
    path: 'campaigns/analytics',
    component: CampaignAnalyticsComponent,
    children: [{ path: 'deliveries', component: CampaignDeliveriesComponent }]
  }
];

export const INSIGHT_ROUTES: Routes = [
  {
    path: 'insights',
    canActivate: [AmplifyAuthGuardService],
    children: [
      { path: 'view/:id', component: ModalContainerInsightComponent },
      {
        path: 'active',
        pathMatch: 'full',
        component: InsightsComponent,
        canActivate: [AmplifyAuthGuardService]
      },
      {
        path: 'inactive',
        pathMatch: 'full',
        component: InsightsComponent,
        canActivate: [AmplifyAuthGuardService]
      }
    ]
  }
];

export const DRB_ROUTES: Routes = [
  {
    path: 'drb/:bundle_name/view',
    component: ViewDrbComponent,
    canActivate: [AmplifyAuthGuardService]
  },
  {
    path: 'drb/:bundle_name/create',
    component: DrbSourcesComponent,
    canActivate: [OktaAuthGuardService]
  },
  {
    path: 'drb/:bundle_name/deploy',
    pathMatch: 'full',
    component: DrbDiffComponent,
    canActivate: [OktaAuthGuardService]
  }
];

export const CONTENT_ROUTES: Routes = [
  {
    path: 'content/table',
    component: ContentComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

export const RFM_ROUTES: Routes = [
  {
    path: 'robot-family-metadata/table',
    component: RobotFamilyMetadataComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

export const SURVEY_ROUTES: Routes = [
  {
    path: 'surveys',
    component: SurveysComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];

export const QUICKSTART_ROUTES: Routes = [
  {
    path: 'quick-start',
    component: QuickStartComponent,
    canActivate: [AmplifyAuthGuardService]
  }
];
